import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine } from '@/fontawesome'

export default function EarningsCalendar() {
  const [theme, setTheme] = useState<'light' | 'dark'>('light')

  useEffect(() => {
    // Initial theme detection
    const isDarkMode = document.documentElement.classList.contains('dark')
    setTheme(isDarkMode ? 'dark' : 'light')

    // Watch for theme changes
    const observer = new MutationObserver(() => {
      const isDarkMode = document.documentElement.classList.contains('dark')
      setTheme(isDarkMode ? 'dark' : 'light')
    })

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })

    return () => observer.disconnect()
  }, [])

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 sm:p-8 shadow-md border border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-green-100 dark:bg-green-900/50 rounded-lg flex items-center justify-center">
          <FontAwesomeIcon icon={faChartLine} className="w-6 h-6 text-green-600 dark:text-green-400" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            Earnings Calendar
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Quartalszahlen und Unternehmensergebnisse
          </p>
        </div>
      </div>

      <div className="w-full">
        <iframe
          src={`https://earningshub.com/embed/calendar?theme=${theme}&calendarView=week&filter=popular`}
          title="Earnings Hub Calendar"
          style={{
            width: '100%',
            height: '800px',
            border: 'none',
          }}
        />
      </div>
    </div>
  )
}
